var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"width":"500","title":"BSJ设置倒车大屏","ok-text":"关闭","cancel-text":""},on:{"on-visible-change":_vm.visibleChange},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},[_c('Button',{attrs:{"type":"primary"},on:{"click":_vm.onSendDriverCardParams}},[_vm._v("发送")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }